







import { Component, Vue, Prop } from 'vue-property-decorator';
import { changeLoading } from '@/util/plugins';
@Component
export default class Space extends Vue {
  @Prop({ type: String, default: '' }) label!: string;
  @Prop({ default: '' }) value!: any;
  @Prop({ type: Number, default: 20 }) mr!: number;
}
